const debugModeFlag = "ENABLE_DEBUG_MODE";
const debugModeBaseObject = "debug";

export interface DebugModeHelperOptions {
  key?: string;
  multi?: boolean;
}

function getDebugContainer() {
  if (!window[debugModeBaseObject]) window[debugModeBaseObject] = {};
  return window[debugModeBaseObject];
}

/**
 * Exposes any Angular component (or any object that may extend OnInit and OnDestroy) to window (only in debug mode)
 *
 * @param {string} [options.key] the key to assign to window
 *  default className (first letter lower-cased) + "Instance" + (multi ? "s" : "")
 * @param {boolean} [options.multi] whether to store multiple values in an array or one value in a field
 *  default false
 * @returns {(class) => void}
 */
export function exposeComponentInDebugMode(options: DebugModeHelperOptions = {}) {
  return function exposeComponentInDebugModeDecorator<T extends {new(...args: any[]): {}}>(constructor: T) {
    const multi = options.multi;
    const key = options.key ||
      `${(constructor.name || "class").replace(/^[A-Z]/, x => x.toLowerCase())}Instance${multi ? "s" : ""}`;

    const originalNgOnInit = constructor.prototype.ngOnInit;
    const originalNgOnDestroy = constructor.prototype.ngOnDestroy;

    if (multi && window[debugModeFlag]) {
      getDebugContainer()[key] = [];
    }

    constructor.prototype.ngOnInit = function ngOnInit(...args: any[]) {
      if (window[debugModeFlag]) {
        if (multi) {
          getDebugContainer()[key].push(this);
        } else {
          getDebugContainer()[key] = this;
        }
      }

      return originalNgOnInit ? originalNgOnInit.apply(this, args) : undefined;
    };

    constructor.prototype.ngOnDestroy = function ngOnDestroy(...args: any[]) {
      if (window[debugModeFlag]) {
        if (multi) {
          const index = getDebugContainer()[key].indexOf(this);
          if (index >= 0) getDebugContainer()[key].splice(index, 1);
        } else if (getDebugContainer()[key] === this) {
          getDebugContainer()[key] = undefined;
        }
      }

      return originalNgOnDestroy ? originalNgOnDestroy.apply(this, args) : undefined;
    };
  };
}
